export class TaskType {
  code: string;
  name: string;
  prefix: string;
  icon: string;
  color: string;
  isSystem: boolean;
  isActive: boolean;

  constructor(payload?: any) {
    if (payload) {
      this.code = payload.code;
      this.name = payload.name;
      this.prefix = payload.prefix;
      this.icon = payload.icon;
      this.color = payload.color;
      this.isSystem = payload.isSystem;
      this.isActive = payload.isActive;
    }
  }

  /**
   * creates task types from a result
   * @param result Array of any
   * @returns Array of TaskType
   */
  static createTaskTypes(result: Array<any>): TaskType[] {
    const taskTypes = new Array<TaskType>();
    if (result) {
      result.map((taskType) => {
        taskTypes.push(new TaskType(taskType));
      });
    }
    return taskTypes;
  }
}
